var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"map",staticClass:"base-map-polygons",attrs:{"center":{lat: 0, lng: 0},"zoom":10,"options":_vm.$options.MAP_OPTIONS,"map-type-id":"terrain"}},_vm._l((_vm.polygons),function(polygon,index){return _c('GmapPolygon',{key:index,ref:"mapPlygon",refInFor:true,attrs:{"path":polygon,"options":_vm.$options.MAP_POLYGON_OPTIONS}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }